import React, { useState } from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { TrustedBy } from './components/TrustedBy';
import { ValueProps } from './components/ValueProps';
import { Services } from './components/Services';
import { Testimonials } from './components/Testimonials';
import { Footer } from './components/Footer';
import { AboutPage } from './pages/AboutPage';
import { ServicesPage } from './pages/ServicesPage';
import { ContactPage } from './pages/ContactPage';
type Page = 'home' | 'about' | 'services' | 'contact';
export function App() {
  const [currentPage, setCurrentPage] = useState<Page>('home');
  const navigateTo = (page: Page) => {
    setCurrentPage(page);
    window.scrollTo(0, 0);
  };
  return <div className="min-h-screen bg-white" data-id="element-0">
      <Header onNavigate={navigateTo} currentPage={currentPage} data-id="element-1" />
      {currentPage === 'home' && <main data-id="element-2">
          <Hero onNavigate={p => navigateTo(p as Page)} data-id="element-3" />
          <TrustedBy data-id="element-4" />
          <ValueProps data-id="element-5" />
          <Services onNavigate={p => navigateTo(p as Page)} data-id="element-6" />
          <Testimonials data-id="element-7" />
        </main>}
      {currentPage === 'about' && <AboutPage onBack={() => navigateTo('home')} data-id="element-8" />}
      {currentPage === 'services' && <ServicesPage onBack={() => navigateTo('home')} data-id="element-9" />}
      {currentPage === 'contact' && <ContactPage onBack={() => navigateTo('home')} data-id="element-10" />}
      <Footer onNavigate={navigateTo} data-id="element-11" />
    </div>;
}